import * as React from "react";

function MinusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M432 256c0 13.3-10.7 24-24 24H40c-13.25 0-24-10.74-24-23.99C16 242.8 26.75 232 40 232h368c13.3 0 24 10.8 24 24z"
  }));
}

const ForwardRef = React.forwardRef(MinusIcon);
export default ForwardRef;